<div class="Container Flexbox Flexbox--column Gap--normal" #container>
  <div class="GemstoneSection AddStonesSection Grid Gap--smaller">
    <h3 class="SectionTitle">Add Stones?</h3>
    <div class="StonesYesNo Flexbox Align--center Gap--smaller">
      <mat-card [class.Selected]="!selectedType()">
      <mat-card-content>
        <button mat-flat-button (click)="removeStones()">
          <div class="Flexbox Align--center Justify--center ButtonContent">
            <span>No</span>
          </div>
        </button>
      </mat-card-content>
    </mat-card>
     <mat-card [class.Selected]="!!selectedType()">
      <mat-card-content>
        <button mat-flat-button (click)="addStones()">
          <div class="Flexbox Align--center Justify--center ButtonContent">
            <span>Yes</span>
          </div>
        </button>
      </mat-card-content>
    </mat-card>
    </div>
  </div>
  @if (!!selectedType()) {
    <div class="GemstoneSection Grid Gap--smaller">
      <h3 class="SectionTitle">Stone</h3>
      @for (type of typesToShow(); track $index) {
        <app-gemstone-card [gemstoneAttributeValue]="type" [isSelected]="selectedType()?.id === type.stoneTypeID && selectedShape()?.id === type.stoneShapeID" (gemstoneAttributeClick)="typeSelected($event)"></app-gemstone-card>
      }
    </div>
    <div class="GemstoneSection Grid Gap--smaller">
      <h3 class="SectionTitle">Size</h3>
       @for (size of sizesToShow(); track $index) {
        <app-gemstone-card [gemstoneAttributeValue]="size" [isSelected]="selectedSize()?.id === size.id" (gemstoneAttributeClick)="sizeSelected($event)"></app-gemstone-card>
      }
    </div>
    <div class="GemstoneSection Grid Gap--smaller">
      <h3 class="SectionTitle">Arrangement</h3>
      @for (arrangement of arrangementsToShow(); track $index) {
        <app-gemstone-card [gemstoneAttributeValue]="arrangement" [isSelected]="selectedArrangement()?.id === arrangement.stoneArrangementID && selectedSetting()?.id === arrangement.stoneSettingID" (gemstoneAttributeClick)="arrangementSelected($event)"></app-gemstone-card>
      }
    </div>
  }
</div>
